// „Verwalten“ am Telefon-Knopf einer Smart View: Anrufe heute (alle Nutzer), wer gerade in dieser Smart View anruft,
// Klingeldauer kurz oder normal (gilt für deine Sitzungen dieser Smart View).
import { useCallback, useEffect, useState } from "react";
import { fehlerText } from "../../api";
import { massenApi, type DialerInfo } from "../../api/leadsNeu";
import { Dialog } from "../Dialog";
import { Icon } from "../Icon";
import { klingeldauerLesen, klingeldauerSetzen, type Klingeldauer } from "./dialer";
import "./smartview.css";

export function DialerVerwaltenDialog({ offen, onSchliessen, viewId, titel }: { offen: boolean; onSchliessen: () => void; viewId: string; titel: string }) {
  const [info, setInfo] = useState<DialerInfo | null>(null);
  const [fehler, setFehler] = useState<string | null>(null);
  const [laedt, setLaedt] = useState(false);
  const [dauer, setDauer] = useState<Klingeldauer>("normal");

  const laden = useCallback(() => {
    setLaedt(true);
    setFehler(null);
    massenApi
      .dialerInfo(viewId)
      .then(setInfo)
      .catch((e) => setFehler(fehlerText(e)))
      .finally(() => setLaedt(false));
  }, [viewId]);

  useEffect(() => {
    if (!offen) return;
    setInfo(null);
    setDauer(klingeldauerLesen(viewId));
    laden();
  }, [offen, viewId, laden]);

  const waehlen = (w: Klingeldauer) => {
    setDauer(w);
    klingeldauerSetzen(viewId, w);
  };
  const k = info?.klingeldauer;

  return (
    <Dialog
      titel={`Power Dialer verwalten · ${titel}`}
      offen={offen}
      onSchliessen={onSchliessen}
      breite={460}
      fuss={
        <>
          <button type="button" className="knopf" onClick={laden} disabled={laedt}>
            Aktualisieren
          </button>
          <button type="button" className="knopf knopf--primaer" onClick={onSchliessen}>
            Fertig
          </button>
        </>
      }
    >
      <div className="svd">
        <div>
          <div className="feld__label">Anrufe heute (alle Nutzer in dieser Smart View)</div>
          <div className="svd__gross">{info ? (info.anrufe_heute === null ? "–" : info.anrufe_heute.toLocaleString("de-DE")) : laedt ? "…" : "–"}</div>
          {info && info.anrufe_heute === null ? <div className="svd__leise">Die Treffer konnten gerade nicht aus Close geholt werden.</div> : null}
        </div>
        <div>
          <div className="feld__label">Ruft gerade an</div>
          {info?.ruft_gerade_an.length ? (
            <ul style={{ margin: 0, paddingLeft: 18 }}>
              {info.ruft_gerade_an.map((w) => (
                <li key={w.user_id}>
                  {w.name}
                  {w.ich ? " (du)" : ""} <span className="svd__leise">· {w.angerufen} angerufen</span>
                </li>
              ))}
            </ul>
          ) : (
            <div className="svd__leise">{info ? "Niemand." : ""}</div>
          )}
        </div>
        <div>
          <div className="feld__label">Klingeldauer beim Kunden</div>
          <div className="svd__chips" role="radiogroup">
            <button type="button" role="radio" aria-checked={dauer === "normal"} className={`knopf knopf--klein${dauer === "normal" ? " knopf--primaer" : ""}`} onClick={() => waehlen("normal")}>
              Normal{k ? ` (${k.standard} s)` : ""}
            </button>
            <button type="button" role="radio" aria-checked={dauer === "kurz"} className={`knopf knopf--klein${dauer === "kurz" ? " knopf--primaer" : ""}`} onClick={() => waehlen("kurz")}>
              Kurz{k ? ` (${k.kurz} s)` : ""}
            </button>
          </div>
          <div className="svd__leise" style={{ marginTop: 4 }}>
            Gilt für deine nächsten Sitzungen in dieser Smart View. Kürzer als {k?.min ?? 25} s geht nicht.
          </div>
        </div>
        {fehler ? (
          <div className="hinweis hinweis--fehler" role="alert">
            <Icon name="warnung" groesse={15} />
            <span>{fehler}</span>
          </div>
        ) : null}
      </div>
    </Dialog>
  );
}
